module.exports = __webpack_public_path__ + "img/logo_white.761b0b38.png";